<section class="custom-page-width auto-margin">
  <div class="header-inner">
    <div class="static-brand">
      <app-logo></app-logo>
    </div>
    <h3 class="static-title">Privacy Policy</h3>
  </div>

  <div class="custom-box padding-box mb-3 d-inline-block full-width">
    @if (privacyPolicy(); as privacyPolicy) {
      <div class="custom-box padding-box">
        <p [innerHtml]="privacyPolicy.content"></p>
      </div>
    }
    @if (isLoading()) {
      <div aria-busy="true" role="status" class="center loader-circle">
        <img imageName="loader.gif" [common]="true" alt="loader" width="80px" />
      </div>
    }

    @if (isError() && !isLoading()) {
      <div class="error-mesg mb-2 empty-box-height">
        <div>
          <img
            aria-hidden="true"
            imageName="something-went-wrong.svg"
            alt="Something went wrong"
            width="100px"
          />
          <p role="alert" class="title-10 text-w-700">{{ errMsg() }}</p>
        </div>
      </div>
    }
  </div>
</section>
